import React from 'react';
import get from 'lodash.get';
import { AnyProps } from '../../components/types';
import { getMappedProps } from '../../components/props';
import { multiLink } from '../../components/props/multi-link';

export const flattenProps = (comp, blok): React.ClassAttributes<AnyProps> =>
  Object.keys(blok).reduce((accumulator, propName) => {
    const props = {
      ...accumulator,
      ...(propName.indexOf('_') !== 0 ? getMappedProps(propName, blok[propName]) : { [propName]: blok[propName] }),
    };
    return {
      ...props,
      // eslint-disable-next-line max-len

      [propName]:
        comp.mappings && comp.mappings[propName] && props[propName] ? get(JSON.parse(props[propName]), comp.mappings[propName]) : props[propName],
    };
  }, {});

export const getFundPropValue = (value, key) => {
  let updatedValue = value;
  if (value?.fieldtype === 'multilink') {
    const multilinkProp = multiLink(key, value);
    updatedValue = multilinkProp[Object.keys(multilinkProp)[0]];
  }
  return typeof updatedValue === 'object' ? JSON.stringify(updatedValue) : updatedValue;
};

export const grabFundsProps = (obj: Story) => {
  const { body, ...rest } = obj;
  rest.background = rest.background.filename;
  const moddedObj = Object.fromEntries(Object.entries(rest).map(([key, value]) => [key.replace(/_/g, '-'), getFundPropValue(value, key)]));

  delete moddedObj['-uid'];
  delete moddedObj['-editable'];
  return moddedObj;
};
